export default "__VITE_ASSET__BFWtHTW3__"